export default __webpack_public_path__ + "static/media/nnana.3094dbbd.jpg";